export enum TelnyxNumberType {
  Local = "local",
  TollFree = "TollFree",
}
